// src/js/components/Evaluation/ModuleQuestion .js
import React, { Component } from "react";
import { connect } from "react-redux";
import {subModuleClick} from "../../actions";
import renderHTML from "react-render-html";
import ModuleAnswer from "./ModuleAnswer";
// import Module from "./Module";

const mapStateToProps = state => {
    return {
        modules: state.data.questionnaire.modules,
        questionsubmitactive: state.questionsubmitactive,
        results: state.results
    };
};

function mapDispatchToProps(dispatch) {
    return {
        subModuleClick: payload => dispatch(subModuleClick(payload))
    };
}

class ConnectedModuleQuestion extends Component {
    constructor(props){
        super(props);
        this.displayAnswers = this.displayAnswers.bind(this);
        this.submitButton = this.submitButton.bind(this);
    }

    displayAnswers(item, index) {
        return (
            <ModuleAnswer key={index} module={this.props.module} submodule={this.props.submodule} answer={index} />
        )
    }

    submitButton() {
        if ( this.props.questionsubmitactive ){
            this.props.subModuleClick(this.props.module)
        }
    }

    render() {
        const thismodule = this.props.modules[this.props.module];
        const thissubmodule = thismodule.submodules[this.props.submodule];
        const questionnumber = parseInt(this.props.submodule,10) + 1;
        const modulenumber = parseInt(this.props.module,10) + 1;
        const totalmodules = this.props.modules.length;

        return(
            <div className="evModuleContainer">
                <div className="evModuleTitleContainer">
                    <div className="evModuleTitle">
                        {renderHTML(thismodule.heading)}
                    </div>
                    <div className="evModuleQuestions">
                        Module {modulenumber} of {totalmodules}<br/>
                        Question {questionnumber} of {thismodule.totalquestions}
                    </div>
                    <div className="evModuleClear">

                    </div>
                </div>
                <div className="evSubModuleTitleContainer">
                    {renderHTML(thissubmodule.heading)}
                </div>
                <div className="evSubModuleText">
                    {renderHTML(thissubmodule.content)}
                </div>
                <div className="evSubModuleQuestion">
                    <div>
                        {renderHTML(thissubmodule.question)}
                    </div>
                </div>
                <div className="evSubModuleAnswer">
                    <ul>
                        {thissubmodule.answers.map((answer,index) => this.displayAnswers(answer, index))}
                    </ul>
                </div>
                <div className="evButtonContainer">
                    <span className={`evButton ${this.props.questionsubmitactive}`} onClick={(e) => this.submitButton()}>Submit answer &gt;</span>
                </div>
            </div>
        )
    }
}
const ModuleQuestion = connect(mapStateToProps,mapDispatchToProps)(ConnectedModuleQuestion);

export default ModuleQuestion;